import { useUserPermissions } from "./hooks/userPermissions";

// Menu items filtrados
export function FilteredMenuItems({ menuItems }) {
  const userPermissions = useUserPermissions();

  const filteredMenuItems = menuItems.filter((item) => {
    if (!item.permission) {
      // Si la ruta no tiene permisos requeridos, se muestra para todos los usuarios
      return true;
    }

    // La ruta tiene permisos requeridos, se comprueba si el usuario los tiene
    return item.permission.every((permission) =>
      userPermissions.includes(permission)
    );
  });

  return filteredMenuItems;
}
